import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css          */
const Link = React.forwardRef(
  ({
    url,
    href,
    target,
    className,
    label = "",
    download,
    children,
    labelAccessibility,
    ariaHasPopup,
    ariaIsExpanded,
    onClick,
    onKeyDown,
    onFocus,
    openInNewWindow,
    tabIndex,
    tealiumAttributes,
    iconBefore,
    iconAfter,
    iconSize,
    isVisualOnly,
    ...rest
  }, ref) => {
    const isNewWindow = target === "external" || target === "_blank" || openInNewWindow;
    const targetOpt = isNewWindow ? "_blank" : void 0;
    const rel = isNewWindow ? "noreferrer noopener" : void 0;
    const hrefFallback = isVisualOnly ? "" : "#";
    const handleClick = (event) => {
      if (isVisualOnly) {
        event?.preventDefault();
      }
      if (onClick) {
        onClick(event);
      }
    };
    const classes = classnames(className, { "link--with-icon": iconBefore || iconAfter }) || void 0;
    return (
      /* The linter throws an error that <a> does not support aria-haspopup.
       * However, the docs disagree and it has been shown to work in our testing with VoiceOver on Chrome
       * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-haspopup#associated_roles
       * */
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      /* @__PURE__ */ React.createElement(
        "a",
        {
          ref,
          className: classes,
          href: href || url || hrefFallback,
          target: targetOpt,
          rel,
          "aria-label": labelAccessibility,
          download,
          "aria-haspopup": ariaHasPopup,
          "aria-expanded": ariaHasPopup ? ariaIsExpanded : void 0,
          onClick: handleClick,
          onKeyDown,
          onFocus,
          "data-t": rest["data-t"],
          tabIndex,
          ...tealiumAttributes
        },
        renderLinkIcon(iconBefore, iconSize),
        children ? children : label,
        renderLinkIcon(iconAfter, iconSize)
      )
    );
  }
);
Link.displayName = "Link";
function renderLinkIcon(icon, iconSize) {
  return icon ? /* @__PURE__ */ React.createElement(Icon, { name: icon, width: iconSize?.width, height: iconSize?.height }) : null;
}
export {
  Link as default
};
//# sourceMappingURL=Link.js.map
